import React, { useState } from "react";
import { deleteField } from "firebase/firestore";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import useUpdatePrediction from "hooks/predictions/useUpdatePrediction";

const FinishButton = ({ prediction }) => {
  const [open, setOpen] = useState(false);
  const { updatePrediction } = useUpdatePrediction();

  const givenTime = new Date(prediction.deadline);
  const now = new Date();
  const isPast = givenTime < now;

  return (
    <div className="flex justify-center">
      <div className="flex flex-col gap-2 text-center w-full">
        {!isPast && prediction.type !== "finished" && (
          <span className="text-[12px] font-[700] text-gray-600">
            Ժամանակից շուտ`
          </span>
        )}
        <Button
          color={prediction.type === "finished" ? "success" : "error"}
          variant="contained"
          className="w-full text-[12px] rounded-[24px]"
          onClick={() => {
            setOpen(true);
          }}
        >
          {prediction.type === "finished" ? "Ավարտված է" : "Ավարտել"}
        </Button>
      </div>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{prediction.title}</DialogTitle>
        <DialogContent dividers>
          <div className="flex flex-col gap-[24px] p-[24px]">
            <span className="text-[#212121] text-[12px] line-clamp-6">
              {prediction.description}
            </span>
            <div className="flex gap-6">
              <Button
                color="success"
                variant="contained"
                className="w-fit rounded-[24px]"
                disabled={prediction.type === "finished"}
                sx={{
                  border:
                    prediction.result === true ? "1px solid green" : "none",
                }}
                onClick={() => {
                  updatePrediction(prediction.id, {
                    type: "finished",
                    result: true,
                  });
                  setOpen(false);
                }}
              >
                Կանխատեսումը Ճիշտ էր
              </Button>
              <Button
                color="error"
                variant="contained"
                className="w-fit rounded-[24px]"
                disabled={prediction.type === "finished"}
                sx={{
                  border:
                    prediction.result === false ? "1px solid #FF0000" : "none",
                }}
                onClick={() => {
                  updatePrediction(prediction.id, {
                    type: "finished",
                    result: false,
                  });
                  setOpen(false);
                }}
              >
                Կանխատեսումը սխալ էր
              </Button>
              <Button
                color="warning"
                variant="contained"
                className="w-fit rounded-[24px]"
                onClick={() => {
                  updatePrediction(prediction.id, {
                    type: "pending",
                    result: deleteField(),
                  });
                  setOpen(false);
                }}
              >
                Չեղարկել արդյունքը
              </Button>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setOpen(false)}>
            Փակել
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FinishButton;
